module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-close-my-issue-23.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-close-my-issue.md
// module id = 599
// module chunks = 183